import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { cloneDeep } from 'lodash'
import SwitchPortal from '@/components/edit/SwitchPortal/index.vue'
import String from '@/components/edit/String/index.vue'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

interface Item {
	label: string
}

type State = 'valid' | 'error' | 'loading'

@Component({
	components: {
		SwitchPortal,
		String,
	},
})
export default class FieldPortal extends Vue {
	@Prop() state!: State
	@Prop() placeholder!: string
	@Prop({ required: true }) model!: any
	@Prop({ default: () => [] }) fieldClassArray!: string[]
	@Prop() readonly!: boolean

	fieldState: boolean | null = null
	fieldModel = this.model

	created() {
		this.setState()
	}

	setState() {
		const loadingIndex = this.fieldClassArray.indexOf('loading')

		if (loadingIndex >= 0) {
			this.fieldClassArray.splice(loadingIndex, 1)
		}

		this.fieldState = null
		switch (this.state) {
			case 'valid':
				this.fieldState = true
				break
			case 'error':
				this.fieldState = false
				break
			case 'loading':
				this.fieldState = null
				this.fieldClassArray.push('loading')
				break
		}

		// this.$forceUpdate() // triggering reactivity
	}

	get htmlClass() {
		return this.fieldClassArray.join(' ')
	}

	onChange($event) {
		this.$emit('input', $event)
	}

	@Watch('state')
	onStateChange(newV, old) {
		this.setState()
	}
}
